/* "My Snackies" member dashboard renderer.
 * Fetches the signed app-proxy endpoints (/apps/loyalty/me + /orders) and
 * fills the cards. No identity handling here — Shopify signs the requests.
 */
(function () {
  if (customElements.get('ys-member-dashboard')) return;

  var TX_LABELS = {
    EARNED: { text: 'Points earned', emoji: '⭐' },
    REDEEMED: { text: 'Reward redeemed', emoji: '🎀' },
    EXPIRED: { text: 'Points expired', emoji: '🍂' },
    ADJUSTED: { text: 'Adjustment', emoji: '🔧' },
    REVERSED: { text: 'Reversal', emoji: '↩️' },
  };

  function fmtDate(iso) {
    return new Date(iso).toLocaleDateString('en-MY', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  // Design-preview fixtures (data-preview="1", dev theme only): realistic
  // sample data so the dashboard can be styled without logging in. Never
  // shown to logged-in members.
  var DAY = 86400000;
  function ago(days) { return new Date(Date.now() - days * DAY).toISOString(); }
  var PREVIEW_ME = {
    ok: true, member: true, isNew: false,
    balance: 385, lifetimeSpend: 383, yearSpend: 383, lastYearSpend: 0, qualifyingSpend: 383,
    birthday: null,
    phone: '+60123456789',
    tier: { key: 'junior', name: 'Junior Cakies', emoji: '🥄', multiplier: 1 },
    nextTier: { name: 'Senior Cakies', emoji: '🧁', multiplier: 1.2, threshold: 400, remainingSpend: 17, progressPct: 96 },
    expiringSoon: null,
    transactions: [
      { at: ago(2),  type: 'EARNED',   points: 55, reference: '#1024' },
      { at: ago(9),  type: 'EARNED',   points: 128, reference: '#1011' },
      { at: ago(16), type: 'REDEEMED', points: -250, reference: 'RM5 Voucher' },
      { at: ago(21), type: 'EARNED',   points: 200, reference: '#0996' }
    ]
  };
  var CDN = 'https://cdn.shopify.com/s/files/1/0631/9089/2604/files/';
  var PREVIEW_ORDERS = {
    ok: true, member: true,
    orders: [
      { name: '#1024', at: ago(1), itemCount: 2, total: { amount: '161.00' }, paymentStatus: 'PAID', fulfillmentStatus: 'UNFULFILLED',
        fulfillMethod: 'Delivery', fulfillDate: '22 Jul 2026',
        items: [{ title: 'Strawberry Yoghurt Mille Crepe', size: '8-inch', quantity: 1, image: CDN + 'D10929B1-945F-4147-991C-EDFC74E445A2_22baaba7-bf17-44ec-94d1-33f643cc1ee0_320x320.png?v=1777895122' }, { title: 'Candles', quantity: 1 }] },
      { name: '#1018', at: ago(4), itemCount: 1, total: { amount: '138.00' }, paymentStatus: 'PAID', fulfillmentStatus: 'FULFILLED',
        fulfillMethod: 'Delivery', fulfillDate: '18 Jul 2026',
        items: [{ title: "The 'Ultimate' Durian Mille Crepe", size: '6-inch', quantity: 1, image: CDN + '9DD5EE1D-19D0-4725-936A-358673E8E440_320x320.png?v=1777895204' }] },
      { name: '#1011', at: ago(7), itemCount: 1, total: { amount: '155.00' }, paymentStatus: 'PAID', fulfillmentStatus: 'FULFILLED',
        fulfillMethod: 'Pickup', fulfillDate: '15 Jul 2026', pickupStore: 'The Exchange TRX',
        items: [{ title: 'Dubai Pistachio Dark Chocolate Cake', size: '8-inch', quantity: 1, image: CDN + '4E3022FA-A4B0-432A-BD17-A2BEA80E5CFC_320x320.png?v=1784021717' }] },
      { name: '#1005', at: ago(10), itemCount: 2, total: { amount: '246.00' }, paymentStatus: 'PAID', fulfillmentStatus: 'FULFILLED',
        fulfillMethod: 'Delivery', fulfillDate: '12 Jul 2026',
        items: [{ title: 'Jasmine Tea Shine Muscat Mille Crepe', size: '6-inch', quantity: 1, image: CDN + '61458677-BFB5-4C51-8023-97BFAAAECC5B_320x320.png?v=1778054001' }, { title: 'Chewy Yam Mochi Cake', size: '6-inch', quantity: 1, image: CDN + 'BB5C7019-14BC-4E07-B75D-850BF231BDED_320x320.png?v=1777895355' }] },
      { name: '#0998', at: ago(15), itemCount: 1, total: { amount: '128.00' }, paymentStatus: 'PAID', fulfillmentStatus: 'FULFILLED',
        fulfillMethod: 'Pickup', fulfillDate: '7 Jul 2026', pickupStore: 'Cheras Maluri',
        items: [{ title: 'Classic Tiramisu Cake', size: '6-inch', quantity: 1, image: CDN + '8C6FF285-537E-4B9C-A5AF-AF7AF18FAA38_320x320.png?v=1778054256' }] },
      { name: '#0990', at: ago(19), itemCount: 1, total: { amount: '160.00' }, paymentStatus: 'PAID', fulfillmentStatus: 'FULFILLED',
        fulfillMethod: 'Delivery', fulfillDate: '3 Jul 2026',
        items: [{ title: 'Oolong Durian Cake', size: '8-inch', quantity: 1, image: CDN + '2919A629-2E75-4B13-B9C5-18E7737D2AC5_320x320.jpg?v=1778054465' }] },
      { name: '#0984', at: ago(24), itemCount: 2, total: { amount: '133.00' }, paymentStatus: 'PAID', fulfillmentStatus: 'FULFILLED',
        fulfillMethod: 'Delivery', fulfillDate: '28 Jun 2026',
        items: [{ title: 'Mixed Fruit Mochi Basque Burnt Cheesecake', size: '6-inch', quantity: 1, image: CDN + 'F98753DA-F92B-4EC2-BA07-714DE2DD79C4_320x320.jpg?v=1778054546' }, { title: 'Cooler Bag + Ice Pack', quantity: 1 }] },
      { name: '#0979', at: ago(30), itemCount: 1, total: { amount: '128.00' }, paymentStatus: 'REFUNDED', fulfillmentStatus: 'UNFULFILLED',
        fulfillMethod: 'Delivery', fulfillDate: '22 Jun 2026',
        items: [{ title: 'Pure Nutty Pistachio Cake', size: '6-inch', quantity: 1, image: CDN + 'EF89DE55-985D-4B08-9BA0-A123FD5B9242_320x320.png?v=1778054727' }] }
    ]
  };

  var PREVIEW_REWARDS = {
    ok: true,
    rewards: [
      { id: 'prev-1', title: 'RM5 Voucher', points: 250, emoji: '🎟️', description: 'RM5 off any order — online or in store.' },
      { id: 'prev-2', title: 'RM10 Voucher', points: 500, emoji: '💝', description: 'RM10 off any order — online or in store.' },
      { id: 'prev-3', title: 'Free Slice Cake', points: 800, emoji: '🍰', description: 'Any slice from the chiller, on us.' }
    ]
  };
  var PREVIEW_VOUCHERS = {
    ok: true, member: true,
    vouchers: [
      { code: 'YS-WELC-DEMO', title: 'Welcome Gift — RM10 Online Voucher', status: 'ACTIVE', expiresAt: ago(-150), qr: null, gift: true, onlineOnly: true },
      { code: 'YS-GF01-DEMO', title: 'RM10 Voucher (Loyalty Gift)', status: 'ACTIVE', expiresAt: ago(-150), qr: null, gift: true, loyalGift: true },
      { code: 'YS-GF02-DEMO', title: 'RM10 Voucher (Loyalty Gift)', status: 'ACTIVE', expiresAt: ago(-150), qr: null, gift: true, loyalGift: true },
      { code: 'YS-GF03-DEMO', title: 'RM5 Voucher (Loyalty Gift)', status: 'ACTIVE', expiresAt: ago(-150), qr: null, gift: true, loyalGift: true },
      { code: 'YS-GF04-DEMO', title: 'RM5 Voucher (Loyalty Gift)', status: 'ACTIVE', expiresAt: ago(-150), qr: null, gift: true, loyalGift: true },
      { code: 'YS-GF05-DEMO', title: 'Free Mini Dessert (Loyalty Gift)', status: 'ACTIVE', expiresAt: ago(-150), qr: null, gift: true, loyalGift: true },
      { code: 'YS-K4PM-7Q2D', title: 'RM5 Voucher', status: 'ACTIVE', expiresAt: ago(-150), qr: null },
      { code: 'YS-W8RT-3NCE', title: 'RM10 Voucher', status: 'USED', usedAt: ago(12), expiresAt: ago(-100), qr: null }
    ]
  };

  function statusChip(o) {
    if (o.paymentStatus === 'REFUNDED' || o.paymentStatus === 'PARTIALLY_REFUNDED') {
      return { label: '↩️ Refunded', cls: 'ys-mydash__status ys-mydash__status--refund' };
    }
    if (o.fulfillmentStatus === 'FULFILLED') {
      return { label: '✅ Delivered', cls: 'ys-mydash__status ys-mydash__status--done' };
    }
    return { label: '🧁 Preparing', cls: 'ys-mydash__status' };
  }

  class YsMemberDashboard extends HTMLElement {
    connectedCallback() {
      // "Stay signed in": Safari drops Shopify sessions, so a signed pass
      // from an earlier login can wake the dashboard for VIEWING. Spending
      // (redeem) and profile edits still demand a real login.
      this._pass = null;
      try { this._pass = localStorage.getItem('ysPass') || null; } catch (e) {}
      this._viaPass = false;
      if (this.dataset.passonly) {
        if (!this._pass) return; // stay hidden; the gate card is showing
        this._viaPass = true;
      }
      this.loadMe();
      this.loadOrders();
      this.initRewards();
      this.loadRewards();
      this.loadVouchers();
    }

    q(sel) { return this.querySelector(sel); }

    // Appends the stay-signed-in pass when running without a live Shopify
    // session (the app proxy signs whatever params it forwards, so the
    // backend can verify the pass exactly like any other request).
    passUrl(url) {
      if (!this._viaPass || !this._pass) return url;
      return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'pass=' + encodeURIComponent(this._pass);
    }

    // True when the member must log in properly first (spending/profile
    // actions during a pass-only session). Offers the login jump.
    needsRealLogin(what) {
      if (!this._viaPass) return false;
      if (window.confirm('To ' + what + ', please log in again first — it only takes a quick email code. Go to login now?')) {
        window.location.href = '/customer_authentication/login?return_to=%2Fpages%2Fmy-snackies';
      }
      return true;
    }

    // Redeem-rewards card: tab switching + redeem taps. Reward rows unlock
    // once the balance is known (see updateRewards, called from loadMe).
    initRewards() {
      var self = this;
      this.querySelectorAll('[data-md-tab]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          self.querySelectorAll('[data-md-tab]').forEach(function (t) {
            t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
          });
          self.querySelectorAll('[data-md-panel]').forEach(function (p) {
            p.hidden = p.dataset.mdPanel !== tab.dataset.mdTab;
          });
        });
      });
      this.querySelectorAll('[data-md-redeem]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.toast('Redemption opens very soon — your points are safe! 🍰✨');
        });
      });
    }

    // ---- Live redemption (E5d) ----

    switchTab(name) {
      this.querySelectorAll('[data-md-tab]').forEach(function (t) {
        t.setAttribute('aria-selected', t.dataset.mdTab === name ? 'true' : 'false');
      });
      this.querySelectorAll('[data-md-panel]').forEach(function (p) {
        p.hidden = p.dataset.mdPanel !== name;
      });
    }

    async loadRewards() {
      var self = this;
      try {
        var data;
        if (this.dataset.preview) {
          data = PREVIEW_REWARDS;
        } else {
          var resp = await fetch('/apps/loyalty/rewards', { headers: { Accept: 'application/json' } });
          data = await resp.json();
          if (!resp.ok || !data.ok) throw new Error('rewards failed');
        }
        var list = this.q('.ys-mydash__rewards');
        if (!list || !data.rewards || !data.rewards.length) return;
        list.innerHTML = '';
        data.rewards.forEach(function (rw) {
          var li = document.createElement('li');
          li.className = 'ys-mydash__reward';
          li.setAttribute('data-md-reward', '');
          li.dataset.points = rw.points;

          var info = document.createElement('div');
          info.className = 'ys-mydash__reward-info';
          var h = document.createElement('h3');
          h.className = 'ys-mydash__reward-title';
          h.textContent = rw.title;
          var d = document.createElement('p');
          d.className = 'ys-mydash__reward-desc';
          d.textContent = (rw.description || '') + (rw.oncePerMember ? (rw.description ? ' · ' : '') + 'One per member!' : '');
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'ys-mydash__reward-cta';
          btn.textContent = 'Redeem for ' + rw.points + ' ⭐';
          btn.addEventListener('click', function () { self.confirmRedeem(rw); });
          var need = document.createElement('p');
          need.className = 'ys-mydash__reward-need';
          need.setAttribute('data-md-reward-need', '');
          info.appendChild(h); info.appendChild(d); info.appendChild(btn); info.appendChild(need);

          var blob = document.createElement('span');
          blob.className = 'ys-mydash__reward-blob';
          blob.setAttribute('aria-hidden', 'true');
          if (rw.image) {
            var pic = document.createElement('img');
            pic.src = rw.image;
            pic.alt = '';
            pic.loading = 'lazy';
            blob.appendChild(pic);
          } else {
            blob.textContent = rw.emoji || '🎁';
          }

          li.appendChild(info); li.appendChild(blob);
          list.appendChild(li);
        });
        this.updateRewards(this._balance || 0);
      } catch (_e) { /* static theme blocks stay as the fallback */ }
    }

    // Phone is the only thing required to redeem (counter verification).
    // Birthday used to be required too — dropped 2026-09-03, it was
    // stopping most eligible members. The nudge card asks for it gently.
    profileGate() {
      if (this.dataset.preview) return false;
      var p = this._profile || {};
      if (p.phone) return false;
      var msg = 'One quick thing before you redeem! 💛\n\nPlease add your phone number in the "My status" card — ' +
        'it\'s how our outlets verify your vouchers.\n\nGo there now?';
      if (window.confirm(msg)) this.goToField('phone');
      return true;
    }

    goToField(which) {
      var target = this.q(which === 'phone' ? '[data-md-phone]' : '[data-md-bday]');
      var input = this.q(which === 'phone' ? '[data-md-phone-input]' : '[data-md-bday-input]');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (input) setTimeout(function () { input.focus(); }, 600);
    }

    // "Complete your profile" card: shows once a member has something
    // worth redeeming (150+ pts) and is missing the phone that unlocks it,
    // or — softer — the birthday that unlocks the yearly treat.
    renderNudge(balance) {
      var box = this.q('[data-md-nudge]');
      if (!box) return;
      var p = this._profile || {};
      var pts = Number(balance) || 0;
      var title = this.q('[data-md-nudge-title]');
      var text = this.q('[data-md-nudge-text]');
      var btn = this.q('[data-md-nudge-btn]');
      var emoji = this.q('[data-md-nudge-emoji]');
      var self = this;
      if (pts < 150 || (p.phone && p.birthday)) { box.hidden = true; return; }
      if (!p.phone) {
        if (emoji) emoji.textContent = '🎁';
        if (title) title.textContent = 'You\u2019ve got ' + pts.toLocaleString() + ' points waiting!';
        if (text) text.textContent = 'Add your phone number to unlock redeeming — it\u2019s how our outlets verify your vouchers. Takes 10 seconds.';
        if (btn) { btn.textContent = 'Add phone number'; btn.onclick = function () { self.goToField('phone'); }; }
        box.classList.remove('ys-mydash__nudge--soft');
      } else {
        if (emoji) emoji.textContent = '🎂';
        if (title) title.textContent = 'One more thing for your birthday';
        if (text) text.textContent = 'Add your birthday and a treat will find you in your birthday month. Optional, but sweet.';
        if (btn) { btn.textContent = 'Add birthday'; btn.onclick = function () { self.goToField('bday'); }; }
        box.classList.add('ys-mydash__nudge--soft');
      }
      box.hidden = false;
    }

    confirmRedeem(reward) {
      if (this.profileGate()) return;
      var self = this;
      var overlay = this.q('[data-md-confirm]');
      if (!overlay) return;
      this.q('[data-md-confirm-text]').textContent =
        'Redeem ' + reward.title + ' for ' + reward.points + ' ⭐?';
      overlay.hidden = false;
      var yes = this.q('[data-md-confirm-yes]');
      var no = this.q('[data-md-confirm-no]');
      var cleanup = function () {
        overlay.hidden = true;
        yes.replaceWith(yes.cloneNode(true));
        no.replaceWith(no.cloneNode(true));
      };
      yes.addEventListener('click', function () { cleanup(); self.doRedeem(reward); }, { once: true });
      no.addEventListener('click', cleanup, { once: true });
    }

    async doRedeem(reward) {
      var self = this;
      if (this.dataset.preview) {
        this.toast('Preview mode — log in to really redeem! ✨');
        return;
      }
      if (this.needsRealLogin('redeem your points')) return;
      try {
        var resp = await fetch('/apps/loyalty/redeem', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ rewardId: reward.id }),
        });
        var data = await resp.json();
        if (!data.ok) {
          if (data.error === 'insufficient_points') {
            this.toast('Not enough points yet — ' + (reward.points - (data.balance || 0)) + ' more to go! ⭐');
          } else if (data.error === 'duplicate_request') {
            this.toast('Hang on — that redemption is already going through! 🧁');
          } else if (data.error === 'already_claimed') {
            this.toast('This treat is one per member — you\u2019ve already claimed yours! 💛');
          } else if (data.error === 'profile_incomplete') {
            this._profile = this._profile || {};
            if ((data.missing || []).indexOf('phone') >= 0) this._profile.phone = null;
            this.profileGate();
          } else if (data.error === 'not_logged_in') {
            if (window.confirm('Your login took a little nap — log in again to redeem? It\u2019s just a quick email code!')) {
              window.location.href = '/customer_authentication/login?return_to=%2Fpages%2Fmy-snackies';
            }
          } else {
            this.toast('Couldn’t redeem right now — try again in a moment. 🥲');
          }
          return;
        }
        this._balance = data.balance;
        var pointsEl = this.q('[data-md-points]');
        if (pointsEl) this.countUp(pointsEl, data.balance);
        this.updateRewards(data.balance);
        this.renderVouchers([data.voucher], true);
        this.switchTab('vouchers');
        this.toast('Redeemed! Your voucher is in My vouchers 🎟️✨');
      } catch (_e) {
        this.toast('Couldn’t redeem right now — try again in a moment. 🥲');
      }
    }

    async loadVouchers() {
      try {
        var data;
        if (this.dataset.preview) {
          data = PREVIEW_VOUCHERS;
        } else {
          var resp = await fetch(this.passUrl('/apps/loyalty/vouchers'), { headers: { Accept: 'application/json' } });
          data = await resp.json();
          if (!resp.ok || !data.ok) throw new Error('vouchers failed');
        }
        this._welcomePending = !!data.welcomePending;
        this.renderVouchers(data.vouchers || [], false);
        this.maybeShowThanks(data.vouchers || []);
      } catch (_e) { /* placeholder text stays */ }
    }

    renderVouchers(vouchers, prepend) {
      var wrap = this.q('[data-md-vouchers]');
      var empty = this.q('[data-md-vouchers-empty]');
      if (!wrap) return;
      if (!prepend) wrap.innerHTML = '';
      if (this._welcomePending && !prepend) {
        var tease = document.createElement('div');
        tease.className = 'ys-mydash__voucher ys-mydash__voucher--tease';
        tease.innerHTML = '<span class="ys-mydash__voucher-qr" aria-hidden="true">🎁</span>' +
          '<div class="ys-mydash__voucher-info">' +
          '<span class="ys-mydash__voucher-status">ON ITS WAY</span>' +
          '<p class="ys-mydash__voucher-title">RM10 Welcome Voucher</p>' +
          '<p class="ys-mydash__voucher-meta">Being prepared for you — refresh in a moment and it\u2019s yours! 💛</p>' +
          '</div>';
        wrap.appendChild(tease);
      }
      if (empty) empty.hidden = (vouchers && vouchers.length) || wrap.children.length ? true : false;
      var frag = document.createDocumentFragment();
      (vouchers || []).forEach(function (v) {
        var dead = v.status !== 'ACTIVE';
        var card = document.createElement('div');
        card.className = 'ys-mydash__voucher' + (dead ? ' is-dead' : '');

        var qr = document.createElement('span');
        qr.className = 'ys-mydash__voucher-qr';
        if (v.qr) {
          var img = document.createElement('img');
          img.src = v.qr;
          img.alt = 'Voucher QR — show at the counter';
          qr.appendChild(img);
        } else {
          qr.textContent = v.onlineOnly ? '🛒' : '🎟️';
        }

        var info = document.createElement('div');
        info.className = 'ys-mydash__voucher-info';
        var status = document.createElement('span');
        status.className = 'ys-mydash__voucher-status';
        status.textContent = v.status === 'ACTIVE' ? 'READY' : v.status;
        var where = document.createElement('span');
        where.className = 'ys-mydash__voucher-where' + (v.onlineOnly ? ' ys-mydash__voucher-where--online' : '');
        where.textContent = (v.onlineOnly ? '🛒 Online only' : (v.storeOnly ? '🏪 In store only' : '🏪 Online + in store')) + (v.minSpend ? ' · min. spend RM' + v.minSpend : '');
        var title = document.createElement('p');
        title.className = 'ys-mydash__voucher-title';
        title.textContent = (v.gift ? '🎁 ' : '') + v.title;
        var code = document.createElement('p');
        code.className = 'ys-mydash__voucher-code';
        code.textContent = v.code;
        var meta = document.createElement('p');
        meta.className = 'ys-mydash__voucher-meta';
        meta.textContent = v.status === 'ACTIVE'
          ? (v.onlineOnly
              ? 'Online only 🛒 — enter code ' + v.code + ' at checkout' + (v.minSpend ? ' on orders of RM' + v.minSpend + ' or more' : '') + ' · valid until ' + fmtDate(v.expiresAt)
              : (v.storeOnly
                  ? 'Collect in store 🏪 — show the QR at any outlet · valid until ' + fmtDate(v.expiresAt)
                  : 'Show the QR at the counter, or use code ' + v.code + ' online · valid until ' + fmtDate(v.expiresAt)))
          : (v.status === 'USED' ? 'Used ' + (v.usedAt ? fmtDate(v.usedAt) : '') : 'Expired ' + fmtDate(v.expiresAt));
        info.appendChild(status); info.appendChild(where); info.appendChild(title); info.appendChild(code); info.appendChild(meta);

        card.appendChild(qr); card.appendChild(info);
        frag.appendChild(card);
      });
      if (prepend && wrap.firstChild) wrap.insertBefore(frag, wrap.firstChild);
      else wrap.appendChild(frag);
    }

    updateRewards(balance) {
      this._balance = balance;
      this.querySelectorAll('[data-md-reward]').forEach(function (row) {
        var cost = Number(row.dataset.points) || 0;
        if (balance >= cost) {
          row.classList.remove('is-locked');
        } else {
          row.classList.add('is-locked');
          var need = row.querySelector('[data-md-reward-need]');
          if (need) need.textContent = (cost - balance).toLocaleString() + ' more points to go ⭐';
        }
      });
    }

    toast(msg) {
      var el = this.parentElement.querySelector('[data-md-toast]') || this.q('[data-md-toast]');
      if (!el) return;
      el.textContent = msg;
      el.classList.add('is-on');
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
    }

    async loadMe() {
      var loading = this.q('[data-md-points-loading]');
      var body = this.q('[data-md-points-body]');
      try {
        var data;
        if (this.dataset.preview) {
          data = PREVIEW_ME;
        } else {
          var resp = await fetch(this.passUrl(this.dataset.me), { headers: { Accept: 'application/json' } });
          data = await resp.json();
          if (!resp.ok || !data.ok || !data.member) {
            // Pass rejected (expired/forged): clear it; the gate stays.
            if (this._viaPass) { try { localStorage.removeItem('ysPass'); } catch (e) {} }
            throw new Error('me failed');
          }
          if (data.pass) { try { localStorage.setItem('ysPass', data.pass); } catch (e) {} }
          if (this._viaPass) {
            this.hidden = false;
            var gate = document.querySelector('[data-md-gate]');
            if (gate) gate.hidden = true;
          }
        }

        var rankIcon = this.q('[data-md-rank-icon]');
        var rankName = this.q('[data-md-rank-name]');
        var rankEarn = this.q('[data-md-rank-earn]');
        if (rankName && data.tier) {
          if (rankIcon) rankIcon.textContent = data.tier.emoji;
          rankName.textContent = data.tier.name;
          if (rankEarn) rankEarn.textContent = data.tier.multiplier ? 'earning ' + data.tier.multiplier + '× points' : '';
        }

        this._tier = data.tier || null;
        this._profile = { phone: data.phone || null, birthday: data.birthday || null };
        var statusEmoji = this.q('[data-md-status-emoji]');
        var statusName = this.q('[data-md-status-name]');
        if (statusName && data.tier) {
          if (statusEmoji) statusEmoji.textContent = data.tier.emoji;
          statusName.textContent = data.tier.name;
        }

        // Rank-driven theming: hero band escalates with the member's rank,
        // and the kitchen-journey path lights up to the current node.
        var RANK_ORDER = ['junior', 'senior', 'lead', 'head'];
        var HERO_TONE = { junior: 'butter', senior: 'pink', lead: 'blue', head: 'brown' };
        var rankKey = data.tier && data.tier.key;
        var rankIdx = RANK_ORDER.indexOf(rankKey);
        var hero = this.q('.ys-mydash__hero');
        if (hero && HERO_TONE[rankKey]) {
          hero.className = hero.className.replace(/ys-mydash__hero--\w+/g, '').trim() +
            ' ys-mydash__hero--' + HERO_TONE[rankKey];
        }
        var nodes = this.querySelectorAll('[data-md-path] .ys-mydash__node');
        nodes.forEach(function (node) {
          var i = RANK_ORDER.indexOf(node.dataset.tier);
          if (i > -1 && i <= rankIdx) node.classList.add('is-reached');
          if (i === rankIdx) node.classList.add('is-current');
        });

        var multEl = this.q('[data-md-multiplier]');
        if (multEl && data.tier && data.tier.multiplier) {
          multEl.textContent = 'Earning ' + data.tier.multiplier + '× points';
        }

        var pointsEl = this.q('[data-md-points]');
        if (pointsEl) this.countUp(pointsEl, Number(data.balance) || 0);
        this.updateRewards(Number(data.balance) || 0);
        this.renderBirthday(data.birthday);
        this.renderPhone(data.phone);
        this.renderNudge(data.balance);
        this.loadMemberCard();

        var fill = this.q('[data-md-progress]');
        var label = this.q('[data-md-progress-label]');
        if (data.nextTier && fill && label) {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              fill.style.width = Math.max(4, data.nextTier.progressPct) + '%';
            });
          });
          label.textContent = 'Spend RM' + data.nextTier.remainingSpend.toLocaleString() +
            ' more this year to become ' + data.nextTier.name + '!';
        } else if (fill && label) {
          fill.style.width = '100%';
          label.textContent = 'Top of the kitchen — Head Cakies! 👨‍🍳✨';
        }

        // Next-rank teaser banner in the Points activity card.
        var banner = this.q('[data-md-nextrank]');
        if (banner) {
          var bEmoji = this.q('[data-md-nextrank-emoji]');
          var pathRoot = this.q('[data-md-path]');
          // Show the same rank artwork as the journey path (falls back to the emoji).
          var setMedal = function (tierName, fallback) {
            if (!bEmoji) return;
            var key = String(tierName || '').split(' ')[0].toLowerCase();
            var art = (key && pathRoot) ? pathRoot.querySelector('[data-tier="' + key + '"] img') : null;
            if (art) { bEmoji.innerHTML = ''; bEmoji.appendChild(art.cloneNode(true)); bEmoji.classList.add('has-img'); }
            else { bEmoji.textContent = fallback; bEmoji.classList.remove('has-img'); }
          };
          var bTitle = this.q('[data-md-nextrank-title]');
          var bPerks = this.q('[data-md-nextrank-perks]');
          var perks = [];
          if (data.nextTier) {
            setMedal(data.nextTier.name, data.nextTier.emoji || '🧁');
            if (bTitle) bTitle.textContent = 'You are RM' + data.nextTier.remainingSpend.toLocaleString() +
              ' away from achieving ' + data.nextTier.name + '!';
            var boost = data.tier && data.tier.multiplier
              ? Math.round((data.nextTier.multiplier / data.tier.multiplier - 1) * 100) : 0;
            perks.push('⭐ Earn ' + data.nextTier.multiplier + '× points on every order' + (boost ? ' — ' + boost + '% more than now' : ''));
            perks.push('🏅 The ' + data.nextTier.name + ' badge on your dashboard');
          } else if (data.tier) {
            setMedal(data.tier.name, data.tier.emoji || '👨‍🍳');
            if (bTitle) bTitle.textContent = 'You run this kitchen — ' + data.tier.name + '!';
            perks.push('⭐ Earning the top ' + data.tier.multiplier + '× points on every order');
          }
          if (bPerks) {
            bPerks.innerHTML = '';
            perks.forEach(function (p) {
              var pl = document.createElement('li');
              pl.textContent = p;
              bPerks.appendChild(pl);
            });
          }
          banner.hidden = false;
        }

        var exp = this.q('[data-md-expiring]');
        if (exp && data.expiringSoon && data.expiringSoon.points > 0) {
          exp.hidden = false;
          exp.textContent = '⏳ ' + data.expiringSoon.points.toLocaleString() + ' points expire on ' + fmtDate(data.expiringSoon.date);
        }

        this.renderActivity(data.transactions || []);
        if (loading) loading.hidden = true;
        if (body) body.hidden = false;
      } catch (_e) {
        this._meTries = (this._meTries || 0) + 1;
        if (this._meTries < 3) {
          var self2 = this;
          setTimeout(function () { self2.loadMe(); }, 1600 * this._meTries);
          return;
        }
        if (loading) loading.textContent = 'Couldn’t load your points — please refresh in a moment. 🍪';
      }
    }

    renderActivity(txs) {
      var list = this.q('[data-md-activity]');
      var empty = this.q('[data-md-activity-empty]');
      if (!list) return;
      if (!txs.length) { if (empty) empty.hidden = false; return; }
      list.innerHTML = '';
      txs.slice(0, 6).forEach(function (tx) {
        var meta = TX_LABELS[tx.type] || { text: tx.type, emoji: '🍩' };
        var TONE = { EARNED: 'earn', REDEEMED: 'redeem', ADJUSTED: 'blue', REVERSED: 'blue' };
        var li = document.createElement('li');
        li.className = 'ys-mydash__act-item' + (TONE[tx.type] ? ' ys-mydash__act-item--' + TONE[tx.type] : '');

        var badge = document.createElement('span');
        badge.className = 'ys-mydash__act-badge';
        badge.textContent = meta.emoji;
        li.appendChild(badge);

        var text = document.createElement('span');
        text.className = 'ys-mydash__act-text';
        var label = document.createElement('span');
        label.className = 'ys-mydash__act-label';
        label.textContent = meta.text + (tx.reference && tx.type === 'EARNED' ? ' · Order ' + tx.reference : tx.reference && tx.type === 'REDEEMED' ? ' · ' + tx.reference : '');
        var sub = document.createElement('span');
        sub.className = 'ys-mydash__act-date';
        sub.textContent = fmtDate(tx.at);
        text.appendChild(label); text.appendChild(sub);
        li.appendChild(text);

        var pts = document.createElement('span');
        var n = Number(tx.points) || 0;
        pts.className = 'ys-mydash__pts' + (n < 0 ? ' ys-mydash__pts--neg' : '');
        pts.textContent = (n > 0 ? '+' : '') + n.toLocaleString() + ' pts';
        li.appendChild(pts);
        list.appendChild(li);
      });
    }

    async loadOrders() {
      var loading = this.q('[data-md-orders-loading]');
      var list = this.q('[data-md-orders]');
      var empty = this.q('[data-md-orders-empty]');
      try {
        var data;
        if (this.dataset.preview) {
          data = PREVIEW_ORDERS;
        } else {
          var resp = await fetch(this.passUrl(this.dataset.orders), { headers: { Accept: 'application/json' } });
          data = await resp.json();
          if (!resp.ok || !data.ok || !data.member) throw new Error('orders failed');
        }
        if (loading) loading.hidden = true;
        var orders = data.orders || [];
        this.helloLine(orders);
        if (!orders.length) { if (empty) empty.hidden = false; return; }
        this._orders = orders;
        this.renderOrdersPage(0);
      } catch (_e) {
        if (loading) loading.textContent = 'Couldn’t load orders right now — refresh in a moment. 🧾';
      }
    }

    // House rule: 4 products per page — extra orders paginate.
    renderOrdersPage(page) {
      var self = this;
      var list = this.q('[data-md-orders]');
      var pager = this.q('[data-md-orders-pager]');
      var PER_PAGE = 4;
      var orders = this._orders || [];
      var pages = Math.ceil(orders.length / PER_PAGE);
      page = Math.max(0, Math.min(page, pages - 1));

      list.innerHTML = '';
      orders.slice(page * PER_PAGE, page * PER_PAGE + PER_PAGE).forEach(function (o) {
          var card = document.createElement('article');
          card.className = 'ys-mydash__ordercard';

          // Media: first product photo, cute fallback else; status sticker on top.
          var media = document.createElement('div');
          media.className = 'ys-mydash__ordercard-media';
          var withImage = (o.items || []).filter(function (i) { return i.image; });
          if (withImage.length) {
            var img = document.createElement('img');
            img.src = withImage[0].image;
            img.alt = withImage[0].title;
            img.loading = 'lazy';
            media.appendChild(img);
          } else {
            media.appendChild(document.createTextNode('🍰'));
          }
          card.appendChild(media);

          var body = document.createElement('div');
          body.className = 'ys-mydash__ordercard-body';

          // Minimal card: one product, one info line, price, share.
          var first = (o.items && o.items[0]) || null;
          var title = document.createElement('h3');
          title.className = 'ys-mydash__ordercard-title';
          title.textContent = first
            ? (first.quantity > 1 ? first.quantity + '× ' : '') + first.title + (first.size ? ' (' + first.size + ')' : '')
            : o.name;
          body.appendChild(title);

          var whenIcon = o.fulfillMethod === 'Pickup' ? '🏬' : o.fulfillMethod === 'Delivery' ? '🚚' : o.fulfillMethod === 'Postage' ? '📦' : '🧾';
          var whenDate = o.fulfillDate || fmtDate(o.at);
          var metaRow = document.createElement('span');
          metaRow.className = 'ys-mydash__ordercard-metarow';
          var meta = document.createElement('span');
          meta.className = 'ys-mydash__ordercard-meta';
          meta.textContent = o.name + ' · ' + whenIcon + ' ' + whenDate;
          metaRow.appendChild(meta);
          var chip = statusChip(o);
          var status = document.createElement('span');
          status.className = 'ys-mydash__ordercard-status' +
            (chip.cls.indexOf('--done') > -1 ? ' ys-mydash__ordercard-status--done' :
             chip.cls.indexOf('--refund') > -1 ? ' ys-mydash__ordercard-status--refund' : '');
          status.textContent = chip.label;
          metaRow.appendChild(status);
          body.appendChild(metaRow);

          if (o.total) {
            var total = document.createElement('span');
            total.className = 'ys-mydash__ordercard-total';
            total.textContent = 'RM' + Number(o.total.amount).toFixed(2);
            body.appendChild(total);
          }

          var share = document.createElement('button');
          share.type = 'button';
          share.className = 'ys-mydash__ordercard-share';
          var ig = document.createElement('span');
          ig.className = 'ys-mydash__ig';
          ig.setAttribute('aria-hidden', 'true');
          ig.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round">' +
            '<rect x="3" y="3" width="18" height="18" rx="5.5"/><circle cx="12" cy="12" r="4.2"/>' +
            '<circle cx="17.3" cy="6.7" r="1.3" fill="#fff" stroke="none"/></svg>';
          share.appendChild(ig);
          share.appendChild(document.createTextNode('Share Story'));
          var whenFull = (o.fulfillMethod ? o.fulfillMethod + ' · ' : '') + whenDate + (o.pickupStore ? ' · ' + o.pickupStore : '');
          share.addEventListener('click', function () { self.shareOrder(o, whenIcon + ' ' + whenFull); });
          body.appendChild(share);

          card.appendChild(body);
          list.appendChild(card);
        });

      if (pager) {
        pager.innerHTML = '';
        pager.hidden = pages <= 1;
        if (pages > 1) {
          var mkBtn = function (label, target, opts) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'ys-mydash__pager-btn';
            b.textContent = label;
            if (opts && opts.current) b.setAttribute('aria-current', 'true');
            if (opts && opts.disabled) b.disabled = true;
            else b.addEventListener('click', function () { self.renderOrdersPage(target); });
            pager.appendChild(b);
          };
          mkBtn('‹', page - 1, { disabled: page === 0 });
          for (var p = 0; p < pages; p++) mkBtn(String(p + 1), p, { current: p === page });
          mkBtn('›', page + 1, { disabled: page === pages - 1 });
        }
      }
    }

    // Personalized hero line: finds the member's most-ordered treat and picks
    // one of ten wordings, rotating daily (Malaysia time) so returning on a
    // different day greets them differently.
    helloLine(orders) {
      var el = this.q('[data-md-hello]');
      if (!el) return;

      // Add-ons never count as someone's "favourite treat".
      var ADDON = /candle|cutlery|utensil|ice\s?pack|topper|knife|greeting|card|bag|tip/i;
      var counts = {};
      (orders || []).forEach(function (o) {
        (o.items || []).forEach(function (i) {
          if (!i.title || ADDON.test(i.title)) return;
          var name = i.title.split(' - ')[0].trim();
          counts[name] = (counts[name] || 0) + (Number(i.quantity) || 1);
        });
      });
      var fave = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; })[0];

      var WITH_FAVE = [
        'Looks like you love our {treat} — glad that you love it! 🤎',
        'A {treat} kind of day, maybe? Excellent taste, as always. 😌',
        'The kitchen noticed: {treat} keeps winning your heart. We approve! 💛',
        'Word around the ovens is you and our {treat} are best friends. 🥰',
        'Your usual? One {treat}, coming right up whenever you’re ready. ✨',
        'Fun fact: {treat} is your most-ordered treat. Iconic duo! 🍰',
        'Our bakers smile every time a {treat} order comes in with your name. 🧁',
        'The {treat} fan club called — you’re basically the president. 🎀',
        'Sweet history says {treat} never lets you down. Neither will we! 💌',
        'Craving check: we’d bet on {treat} today. Are we right? 👀'
      ];
      var NO_ORDERS = [
        'Your first treat is out there waiting — the kitchen can’t wait to meet you! 🍰',
        'Fresh apron, fresh start — your first order earns your first points! ⭐',
        'The ovens are warm and the chiller is full — come pick your first favourite! 🧁'
      ];
      var FUN_FACTS = [
        'Do you know the difference between dairy and non-dairy cream? Dairy whips from real milk fat for a richer melt; non-dairy is plant-based and holds its swirl longer in KL heat! 🥛',
        'Do you know why it’s called a MILLE crepe? “Mille” means a thousand in French — every cake stacks layer upon paper-thin layer, each cooked one at a time! 🥞',
        'Do you know when cake tastes best? About 15–20 minutes out of the fridge — the cream softens and the flavours wake up! ⏱️',
        'Do you know why good matcha is gently bitter? That’s the tea’s natural amino acids — bright green and fresh, never burnt! 🍵',
        'Do you know the secret to a fresh-tasting cream? A touch of yoghurt — its tang cuts the sweetness for that light finish! 🍓',
        'Do you know why your cake box arrives chilled? Fresh cream is happiest cold — straight into the fridge until treat time! ❄️',
        'Do you know that strawberries stop ripening the moment they’re picked? Sweetness on day one is everything! 🍓',
        'Do you know what makes sponge cake fluffy? Whipped eggs, not baking powder — tiny air bubbles do all the lifting! 🥚',
        'Do you know the bakery trick for clean slices? A warm, dry knife — dip it in hot water, wipe, then cut! 🔪',
        'Do you know every RM1 you spend earns Cakies points? This dashboard is exactly where they pile up! ⭐'
      ];

      // Day index in Malaysia time (UTC+8): stable all day, changes tomorrow.
      // Pool = personalized lines (or first-order lines) + fun facts, so the
      // greeting alternates flavours across the days.
      var day = Math.floor((Date.now() + 8 * 3600 * 1000) / 86400000);
      var pool = (fave
        ? WITH_FAVE.map(function (l) { return l.replace('{treat}', fave); })
        : NO_ORDERS
      ).concat(FUN_FACTS);
      el.textContent = pool[day % pool.length];
      el.hidden = false;
    }

    // Build a 1080×1920 Instagram-story image of one order and hand it to the
    // native share sheet (mobile: Instagram appears as a target). Desktop or
    // no-share-API: the image downloads instead.
    async shareOrder(o, whenText) {
      var self = this;
      try {
        var W = 1080, H = 1920;
        var c = document.createElement('canvas');
        c.width = W; c.height = H;
        var x = c.getContext('2d');

        // Spotify-share structure, Yoursnackies skin: one flat bold color,
        // floating art with a deep shadow, heavy type, one chip. Background
        // rotates through the house palette per order number.
        var PALETTES = [
          { bg: '#a94030', ink: '#f7f2e7', sub: 'rgba(247,242,231,0.75)', chipBg: '#f7f2e7', chipInk: '#a94030' },
          { bg: '#94bfcc', ink: '#ffffff', sub: 'rgba(255,255,255,0.8)',  chipBg: '#8b6847', chipInk: '#ffffff' },
          { bg: '#fbebac', ink: '#8b6847', sub: 'rgba(139,104,71,0.7)',   chipBg: '#8b6847', chipInk: '#fbebac' },
          { bg: '#ecc5cc', ink: '#8b6847', sub: 'rgba(139,104,71,0.7)',   chipBg: '#ffffff', chipInk: '#8b6847' }
        ];
        var P = PALETTES[(parseInt(String(o.name).replace(/\D/g, ''), 10) || 0) % PALETTES.length];

        x.fillStyle = P.bg; x.fillRect(0, 0, W, H);

        // A few sprinkles, house-style, kept sparse
        x.save();
        x.globalAlpha = 0.5; x.fillStyle = P.ink;
        [[130, 300, -0.5], [950, 260, 0.6], [110, 1560, 0.4], [960, 1620, -0.4]].forEach(function (s) {
          x.save(); x.translate(s[0], s[1]); x.rotate(s[2]);
          x.beginPath(); x.roundRect(-22, -6, 44, 12, 6); x.fill(); x.restore();
        });
        x.globalAlpha = 0.35;
        [[210, 420], [880, 400], [180, 1470], [890, 1500]].forEach(function (d) {
          x.beginPath(); x.arc(d[0], d[1], 9, 0, 7); x.fill();
        });
        x.restore();

        await (document.fonts && document.fonts.ready);
        var font = function (px, w) { return (w || 700) + ' ' + px + 'px Grandstander, "Comic Sans MS", sans-serif'; };
        x.textAlign = 'center';

        // Wordmark top (typographic, always in ink color)
        x.fillStyle = P.ink;
        x.font = font(58);
        x.fillText('YOURSNACKIES', W / 2, 226);
        x.font = font(30);
        x.fillText('D E S S E R T S', W / 2, 282);

        // Floating art: big square, slight tilt, deep soft shadow
        var img = (o.items || []).filter(function (i) { return i.image; })[0];
        var size = 760, cx = W / 2, cy = 830, tilt = -0.03;
        x.save();
        x.translate(cx, cy); x.rotate(tilt);
        x.shadowColor = 'rgba(0,0,0,0.32)';
        x.shadowBlur = 70; x.shadowOffsetY = 40;
        if (img) {
          var pic = new Image();
          pic.crossOrigin = 'anonymous';
          await new Promise(function (ok, bad) { pic.onload = ok; pic.onerror = bad; pic.src = img.image; });
          x.beginPath(); x.roundRect(-size / 2, -size / 2, size, size, 44); x.fill();
          x.shadowColor = 'transparent';
          x.clip();
          x.drawImage(pic, -size / 2, -size / 2, size, size);
        } else {
          x.fillStyle = '#ffffff';
          x.beginPath(); x.roundRect(-size / 2, -size / 2, size, size, 44); x.fill();
          x.shadowColor = 'transparent';
          x.font = '340px serif';
          x.fillText('🍰', 0, 120);
        }
        x.restore();

        // Title, Spotify-big (max 2 lines)
        var label = (o.items && o.items.length)
          ? (o.items[0].quantity > 1 ? o.items[0].quantity + '× ' : '') + o.items[0].title + (o.items[0].size ? ' (' + o.items[0].size + ')' : '')
          : o.name;
        x.fillStyle = P.ink; x.font = font(68);
        var words = label.split(' '), lines = [''], li = 0;
        words.forEach(function (w) {
          if (x.measureText(lines[li] + ' ' + w).width > W - 200) { lines[++li] = w; }
          else lines[li] = (lines[li] + ' ' + w).trim();
        });
        var titleY = 1330;
        lines.slice(0, 2).forEach(function (l, n) { x.fillText(l, W / 2, titleY + n * 84); });
        var afterTitle = titleY + Math.min(lines.length, 2) * 84;

        // Sub line (like the artist row)
        x.fillStyle = P.sub; x.font = font(40);
        x.fillText(o.name + '  ·  ' + whenText, W / 2, afterTitle + 26);

        // Chip (like Spotify's action pill): total + club
        var chipText = (o.total ? 'RM' + Number(o.total.amount).toFixed(2) + '  ·  ' : '') + 'The Cakies Club ⭐';
        x.font = font(38);
        var tw = x.measureText(chipText).width;
        var chipW = tw + 96, chipH = 92, chipY = afterTitle + 90;
        x.fillStyle = P.chipBg;
        x.beginPath(); x.roundRect(W / 2 - chipW / 2, chipY, chipW, chipH, 46); x.fill();
        x.fillStyle = P.chipInk;
        x.fillText(chipText, W / 2, chipY + 59);

        // Footer domain, quiet
        x.fillStyle = P.sub; x.font = font(32);
        x.fillText('yoursnackiesdesserts.com', W / 2, H - 96);

        var blob = await new Promise(function (ok) { c.toBlob(ok, 'image/png'); });
        var file = new File([blob], 'yoursnackies-order.png', { type: 'image/png' });
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          await navigator.share({ files: [file], title: 'My Yoursnackies order' });
        } else {
          var a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = 'yoursnackies-order.png';
          a.click();
          URL.revokeObjectURL(a.href);
          self.toast('Story image saved — post it and tag us! 📸');
        }
      } catch (err) {
        if (err && err.name === 'AbortError') return; // user closed the share sheet
        self.toast('Couldn’t make the share image — try again? 🥲');
      }
    }

    // Birthday capture — set once, then locked (anti-cheat rule from Sam).
    renderBirthday(birthday) {
      var self = this;
      var wrap = this.q('[data-md-bday]');
      if (!wrap) return;
      var setEl = this.q('[data-md-bday-set]');
      var form = this.q('[data-md-bday-form]');
      wrap.hidden = false;
      if (birthday) {
        var d = new Date(birthday + 'T00:00:00');
        setEl.textContent = '🎂 Birthday: ' + d.toLocaleDateString('en-MY', { day: 'numeric', month: 'long' }) + ' · locked in!';
        setEl.hidden = false; form.hidden = true;
        return;
      }
      form.hidden = false; setEl.hidden = true;
      var btn = this.q('[data-md-bday-save]');
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var val = self.q('[data-md-bday-input]').value;
        if (!val) { self.toast('Pick your birthday first! 🎂'); return; }
        if (!window.confirm('Lock in ' + new Date(val + 'T00:00:00').toLocaleDateString('en-MY', { day: 'numeric', month: 'long', year: 'numeric' }) + ' as your birthday? It cannot be changed later.')) return;
        if (self.dataset.preview) {
          self.renderBirthday(val);
          self.toast('Preview mode — log in to really save! ✨');
          return;
        }
        if (self.needsRealLogin('save your birthday')) return;
        btn.disabled = true;
        fetch('/apps/loyalty/birthday', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ birthday: val }),
        }).then(function (r) { return r.json(); }).then(function (d) {
          if (d.ok) { if (self._profile) self._profile.birthday = d.birthday; self.renderBirthday(d.birthday); self.renderNudge(self._balance); self.toast('Birthday saved — a treat will find you! 🎂'); }
          else if (d.error === 'birthday_locked') { self.toast('Your birthday is already locked in! 🎂'); }
          else { self.toast('Couldn’t save right now — try again? 🥲'); }
        }).catch(function () { self.toast('Couldn’t save right now — try again? 🥲'); })
          .finally(function () { btn.disabled = false; });
      });
    }

    // Phone capture — the number staff use to verify members in store.
    // Editable (unlike birthday): typos must be fixable by the member.
    renderPhone(phone) {
      var self = this;
      var wrap = this.q('[data-md-phone]');
      if (!wrap) return;
      wrap.hidden = false;
      var input = this.q('[data-md-phone-input]');
      if (phone && !input.dataset.touched) input.value = phone;
      var btn = this.q('[data-md-phone-save]');
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      input.addEventListener('input', function () { input.dataset.touched = '1'; });
      btn.addEventListener('click', function () {
        var val = input.value.trim();
        if (!val) { self.toast('Type your phone number first! 📱'); return; }
        if (self.dataset.preview) {
          self.toast('Preview mode — log in to really save! ✨');
          return;
        }
        if (self.needsRealLogin('update your phone number')) return;
        btn.disabled = true;
        fetch('/apps/loyalty/phone', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ phone: val }),
        }).then(function (r) { return r.json(); }).then(function (d) {
          if (d.ok) {
            input.value = d.phone;
            delete input.dataset.touched;
            if (self._profile) self._profile.phone = d.phone;
            self.renderNudge(self._balance);
            self.toast('Phone number saved! 📱');
          }
          else if (d.error === 'bad_phone') { self.toast('That doesn’t look like a Malaysian mobile number — check it? 📱'); }
          else if (d.error === 'phone_taken') { self.toast('That number belongs to another member — please WhatsApp us if that’s wrong! 💬'); }
          else { self.toast('Couldn’t save right now — try again? 🥲'); }
        }).catch(function () { self.toast('Couldn’t save right now — try again? 🥲'); })
          .finally(function () { btn.disabled = false; });
      });
    }

    // Member card — permanent in-store QR ("YSM:" payload). Staff scan it
    // on the Earn tab instead of keying a phone number.
    loadMemberCard() {
      var self = this;
      var wrap = this.q('[data-md-card-wrap]');
      if (!wrap || wrap.dataset.loaded) return;
      wrap.dataset.loaded = '1';
      var img = this.q('[data-md-card-qr]');
      var wait = this.q('[data-md-card-wait]');
      var nameEl = this.q('[data-md-card-name]');
      wrap.hidden = false;
      if (this.dataset.preview) {
        wait.textContent = '💳 Your QR appears here';
        nameEl.textContent = 'Snackie (preview)';
        return;
      }
      nameEl.textContent = this.dataset.customerName || 'Cakies Club member';
      fetch(this.passUrl('/apps/loyalty/member-card'), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.ok && d.qr) {
            img.src = d.qr;
            img.hidden = false;
            wait.hidden = true;
            if (d.name) nameEl.textContent = d.name;
            var saveBtn = self.q('[data-md-card-save]');
            if (saveBtn) {
              saveBtn.hidden = false;
              saveBtn.addEventListener('click', function () {
                self.saveMemberCard(d.qr, nameEl.textContent);
              });
            }
          } else {
            wait.textContent = 'Card unavailable right now — try again later 🥲';
          }
        })
        .catch(function () { wait.textContent = 'Card unavailable right now — try again later 🥲'; });
    }

    // "Save my card": composes a branded card image (wordmark, QR, name,
    // rank) and hands it to the share sheet (mobile -> Save Image) or
    // downloads it. Gallery beats Wallet here: every phone, zero cost.
    async saveMemberCard(qrSrc, name) {
      var self = this;
      try {
        var qr = await new Promise(function (ok, bad) {
          var im = new Image();
          im.onload = function () { ok(im); };
          im.onerror = bad;
          im.src = qrSrc;
        });

        var W = 1080, H = 1400;
        var c = document.createElement('canvas');
        c.width = W; c.height = H;
        var x = c.getContext('2d');
        var font = function (px, w) { return (w || 700) + ' ' + px + 'px Grandstander, "Comic Sans MS", sans-serif'; };
        var CREAM = '#f7f2e7', BROWN = '#8b6847', BUTTER = '#fbebac', BRICK = '#a94030', PAPER = '#fffdf7';

        x.fillStyle = CREAM; x.fillRect(0, 0, W, H);

        // Brick header band with a scalloped bottom edge
        var bandH = 230;
        x.fillStyle = BRICK; x.fillRect(0, 0, W, bandH);
        for (var sx = 20; sx < W + 40; sx += 40) {
          x.beginPath(); x.arc(sx, bandH, 20, 0, Math.PI * 2); x.fill();
        }
        x.fillStyle = CREAM; x.textAlign = 'center';
        x.font = font(64);
        x.fillText('YOURSNACKIES', W / 2, 105);
        x.fillStyle = BUTTER; x.font = font(34);
        x.fillText('THE CAKIES CLUB · MEMBER CARD', W / 2, 165);

        // White card with the QR
        var cardW = 760, cardX = (W - cardW) / 2, cardY = 320, cardHt = 820;
        x.fillStyle = 'rgba(139,104,71,0.18)';
        x.beginPath(); x.roundRect(cardX, cardY + 10, cardW, cardHt, 40); x.fill();
        x.fillStyle = PAPER;
        x.beginPath(); x.roundRect(cardX, cardY, cardW, cardHt, 40); x.fill();

        var qrSize = 560;
        x.drawImage(qr, (W - qrSize) / 2, cardY + 55, qrSize, qrSize);

        x.fillStyle = BROWN; x.font = font(52);
        x.fillText(String(name || 'Cakies Club member').slice(0, 26), W / 2, cardY + qrSize + 145);
        var tier = this._tier || {};
        x.font = font(38);
        x.fillStyle = '#5f93a3';
        x.fillText((tier.emoji ? tier.emoji + ' ' : '') + (tier.name || 'Cakies Club'), W / 2, cardY + qrSize + 205);

        x.fillStyle = BROWN; x.font = font(32);
        x.globalAlpha = 0.75;
        x.fillText('Show at any outlet to collect points 💛', W / 2, H - 130);
        x.globalAlpha = 0.5; x.font = font(26);
        x.fillText('yoursnackiesdesserts.com', W / 2, H - 75);
        x.globalAlpha = 1;

        var blob = await new Promise(function (ok) { c.toBlob(ok, 'image/png'); });
        var file = new File([blob], 'cakies-member-card.png', { type: 'image/png' });
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          await navigator.share({ files: [file], title: 'My Cakies Club member card' });
        } else {
          var a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = 'cakies-member-card.png';
          document.body.appendChild(a); a.click(); a.remove();
          setTimeout(function () { URL.revokeObjectURL(a.href); }, 4000);
        }
        this.toast('Card saved — see you at the counter! 💳');
      } catch (err) {
        if (err && err.name === 'AbortError') return; // share sheet closed
        this.toast('Couldn’t save the card — try again? 🥲');
      }
    }

    // Loyal-customer thank-you popup: shows once when the wallet contains
    // loyalty-gift vouchers.
    maybeShowThanks(vouchers) {
      var self = this;
      try {
        var loyal = (vouchers || []).filter(function (v) { return v.loyalGift; });
        if (!loyal.length) return;
        if (localStorage.getItem('ysLoyalThanksSeen')) return;
        var modal = this.q('[data-md-thanks]');
        if (!modal) return;

        var nameEl = this.q('[data-md-thanks-name]');
        if (nameEl) nameEl.textContent = this.dataset.customerName || 'Snackie';

        // Their exact gift list, with emoji per kind
        var EMOJI = function (t) {
          return t.indexOf('RM10') === 0 ? '💝' : t.indexOf('RM5') === 0 ? '🎟️'
            : t.indexOf('Free Mini') === 0 ? '🧁' : t.indexOf('Free Slice') === 0 ? '🍰' : '🎁';
        };
        var counts = {};
        loyal.forEach(function (v) {
          var t = v.title.replace(' (Loyalty Gift)', '');
          counts[t] = (counts[t] || 0) + 1;
        });
        var list = this.q('[data-md-thanks-list]');
        if (list) {
          list.innerHTML = '';
          Object.keys(counts).forEach(function (t) {
            var li = document.createElement('li');
            li.textContent = EMOJI(t) + ' ' + counts[t] + '× ' + t;
            list.appendChild(li);
          });
        }
        var cmp = this.q('[data-md-thanks-compare]');
        if (cmp) cmp.textContent = 'That\u2019s ' + loyal.length + ' extra gifts — new members get 1. You\u2019ve earned it! 🤎';
        modal.hidden = false;
        var done = function () { modal.hidden = true; try { localStorage.setItem('ysLoyalThanksSeen', '1'); } catch (e) {} };
        this.q('[data-md-thanks-close]').addEventListener('click', done, { once: true });
        this.q('[data-md-thanks-open]').addEventListener('click', function () {
          done();
          self.switchTab('vouchers');
          var card = self.q('[data-md-vouchers]');
          if (card) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, { once: true });
      } catch (e) { /* never break the dashboard over a popup */ }
    }

    countUp(el, target) {
      var duration = 700;
      var start = performance.now();
      function tick(now) {
        var t = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - t, 3);
        el.textContent = Math.round(target * eased).toLocaleString();
        if (t < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
  }

  customElements.define('ys-member-dashboard', YsMemberDashboard);
})();
